import React from "react";
import "bootstrap-italia/dist/css/bootstrap-italia.min.css";
import "./App.css";
import Repo from "./Utility/Repo";
import { createContext, useEffect, useState } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { MemoizedFooter } from "./Layout/Footer";
import { MemoizedHeader } from "./Layout/Header";
import Body from "./Layout/Body";
import { useCookies } from "react-cookie";
import jwt_decode from "jwt-decode";
import iconSprite from "bootstrap-italia/dist/svg/sprite.svg";
import { TokenContext } from "./Components/TokenContext";
import LabelsLoader from "./Utility/labelsLoader";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

function App() {
  const [cookies] = useCookies();
  const [apiToken] = useState(cookies.api_token);
  const [user, setUser] = useState();
  const [userProfile, setUserProfile] = useState();
  const [showButton, setShowButton] = useState(false);
  const [userStatus, setUserStatus] = useState(false);
  const [userData, setUserData] = useState(false);
  const [userDataStatus, setUserDataStatus] = useState(true);
  const [userISEEValid, setUserISEEValid] = useState(true);
  const [attivita, setAttivita] = useState(false);
  const [userRole, setUserRole] = useState(false);
  const [operator, setOperator] = useState(false);
  const [delegate, setDelegate] = useState(false);
  const [citizen, setCitizen] = useState(false);
  const [subfolder, setSubFolder] = useState(process.env.PUBLIC_URL);

  const labels = LabelsLoader();

  useEffect(() => {
    if (cookies.api_token && !userData) {
      var decoded = jwt_decode(cookies.api_token);
      setUser(decoded.FullName);
      setUserData(true);
    }

    var decoded = {};

    if (apiToken !== undefined) {
      decoded = jwt_decode(apiToken);

      if (decoded.role.includes("OPERATOR")) {
        setOperator(true);
        if (decoded.role.includes("USER")) {
          setUserRole(true);
          setOperator(false);
        } else if (decoded.role.includes("EXECUTIVE")) {
          setAttivita(true);
          setOperator(false);
          setDelegate(false);
        } else if (decoded.role.includes("DELEGATE")) {
          setAttivita(false);
          setOperator(false);
          setDelegate(true);
        }
      } else if (decoded.role.includes("DELEGATE")) {
        setDelegate(true);
        setOperator(false);
        setDelegate(false);
      } else if (decoded.role.includes("CITIZEN")) {
        setCitizen(true);
        setOperator(false);
        // Chiamare getUserInfo solo se citizen è vero
        Repo.getUserInfo(apiToken)
          .then((response) => {
            if (!response.data) {
              setUserDataStatus(true);
            } else {
              setUserDataStatus(false);
            }
            setUserStatus(true);
          })
          .catch((error) => {
            setUserDataStatus(false);
            setUserStatus(false);
            console.log(error);
          });
      }
    }
  }, [cookies]);

  let interval;
  useEffect(() => {
    interval = setInterval(() => {
      localStorage.clear();
      window.location.href = subfolder + "/";
    }, 32400000);
  }, [interval]);

  const listaLinkUser = [
    { testo: "Home", url: "/" },
    { testo: "Iscrizioni", url: "/iscrizioni" },
    { testo: "Profilo", url: "/profilo" },
    { testo: "Supporto", url: "/supporto" },
  ];

  const listaLinkUserRole = [{ testo: "Home", url: "/" }];

  const listaLinkDelegate = [
    { testo: "Home", url: "/" },
    { testo: "Utenti", url: "/lista_utenti" },
    { testo: "Interventi", url: "/lista_interventi" },
  ];

  const listaLinkOperator = [
    { testo: "Home", url: "/" },
    { testo: "Utenti", url: "/lista_utenti" },
    //{ testo: "Esercenti", url: "/esercenti" },
    {
      testo: "Servizi Sociali ",
      submenu: [
        { testo: "Lista Interventi", url: "/lista_interventi" },
        { testo: "Categorie", url: "/categorie" },
      ],
    },

    { testo: labels.flussimypay, url: "/pagamenti" },
    //   { testo: "Buoni Servizio", url: "/buoni_servizio" },
    //{ testo: "Rendicontazione", url: "/rendicontazione" },
    { testo: "Fasce ISEE", url: "/fasce" },
    /*{
      testo: "Configurazione",
      submenu: [
        { testo: "Fasce", url: "/fasce" },
        { testo: "Parametri", url: "/configurazione" },
      ],
    },*/
  ];

  const listaLinkAttivita = [
    { testo: "Home", url: "/" },
    { testo: "Utenti", url: "/lista_utenti" },
    { testo: "Interventi", url: "/lista_interventi" },
  ];
  const listaLink = [{ testo: "Home", url: "/" }];

  const returnlink = () => {
    if (delegate) {
      return listaLinkDelegate;
    } else if (operator) {
      return listaLinkOperator;
    } else if (citizen) {
      return listaLinkUser;
    } else if (attivita) {
      return listaLinkAttivita;
    } else if (userRole) {
      return listaLinkUserRole;
    } else {
      return listaLink;
    }
  };

  useEffect(() => {
    const handleScrollButtonVisibility = () => {
      window.pageYOffset > 300 ? setShowButton(true) : setShowButton(false);
    };

    window.addEventListener("scroll", handleScrollButtonVisibility);

    return () => {
      window.removeEventListener("scroll", handleScrollButtonVisibility);
    };
  }, []);

  return (
    <div className="App">
      {showButton && (
        <a className="backToTop" onClick={() => window.scrollTo(0, 0)}>
          <svg style={{ marginTop: "8px" }} className="icon icon-white">
            <use href={`${iconSprite}#it-arrow-up`}></use>
          </svg>
        </a>
      )}
      <TokenContext.Provider value={apiToken}>
        <Router {...(subfolder && { basename: subfolder })}>
          <div className="headerCustom">
            <MemoizedHeader
              Name={user}
              url="#"
              Title={labels.titolo}
              links={returnlink()}
              subfolder={subfolder ? subfolder : ""}
            />
          </div>
          <Body
            userDataStatus={userDataStatus}
            subfolder={subfolder ? subfolder : ""}
          ></Body>
          <MemoizedFooter
            subfolder={subfolder ? subfolder : ""}
            delegate={delegate}
            operator={operator}
            attivita={attivita}
          ></MemoizedFooter>
        </Router>
      </TokenContext.Provider>
    </div>
  );
}

export default App;
